import { useState, useEffect, memo } from "react";
import { CountUp } from "use-count-up";
import { useAppSelector } from "redux-share/hooks";
import { handleSumVotes, isSelectedOption, isVoted, livePoll } from "helpers";
import { IPollOptionProps } from "interfaces";
import { shallowEqual } from "react-redux";

const PollOption = ({ option, lastOptionId, sumVotes, onClick }: IPollOptionProps) => {
    const [previousVoteWidth, setPreviousVoteWidth] = useState<number>(0);
    const [voteWidth, setVoteWidth] = useState<number>(0);

    const { question, selectedOptionId } = useAppSelector(
        ({ videoData: { question, selectedOptionId } }) => ({ question, selectedOptionId }),
        shallowEqual
    );

    const handleVoteWidth = (vote: number, id: number) => {
        let notUpdateVote = [];
        let sumPercent = 0;
        let sumVotes = handleSumVotes(question);
        if (livePoll())
            notUpdateVote = livePoll().polls.filter((poll: any) => poll.qid === question.id && poll.oid === id && poll.sumOptionVotes === vote + 1);
        if (option.id === lastOptionId) {
            if (vote === 0 && notUpdateVote.length === 0) return 0;
            let otherUpdatedVote: any = [];
            question.options.forEach((option: any) => {
                if (option.id !== lastOptionId) {
                    if (livePoll())
                        otherUpdatedVote = livePoll().polls.filter(
                            (poll: any) => poll.qid === question.id && poll.oid === option.id && poll.sumOptionVotes === option.vote + 1
                        );
                    sumPercent =
                        sumPercent + Math.floor(sumVotes ? ((otherUpdatedVote.length > 0 ? option.vote + 1 : option.vote) * 100) / sumVotes : 0);
                    otherUpdatedVote = [];
                }
            });
            return 100 - sumPercent;
        } else {
            return sumVotes ? ((notUpdateVote.length > 0 ? vote + 1 : vote) * 100) / sumVotes : 0;
        }
    };

    useEffect(() => setVoteWidth(handleVoteWidth(option.vote, option.id)), [option.vote, selectedOptionId, sumVotes]);

    return (
        <p
            key={option.id}
            className={`pl-bg-dark-6 dark:pl-bg-dark-2/[0.9] pl-w-full pl-flex pl-flex-col pl-justify-center pl-items-center pl-text-[13px] pl-px-3 pl-h-[45px] pl-rounded-[12px] ${
                isVoted(question.id) || !question.can_vote ? "pl-cursor-default" : "pl-cursor-pointer"
            } ${isSelectedOption(question.id, option.id) && "!pl-bg-purple-light dark:!pl-bg-main-light/[0.7]"}`}
            onClick={onClick}
        >
            <span className="pl-text-[13px] pl-font-medium pl-text-gray-800 dark:pl-text-white">{option.text}</span>
            {(isVoted(question.id) || !question.can_vote) && (
                <span>
                    <CountUp
                        isCounting={true}
                        duration={4}
                        key={voteWidth}
                        start={+Math.floor(previousVoteWidth).toFixed(0)}
                        end={+Math.floor(voteWidth).toFixed(0)}
                        onComplete={() => setPreviousVoteWidth(voteWidth)}
                    />
                    %
                </span>
            )}
        </p>
    );
};

export default memo(PollOption);
